/* Disputes (M6.6) — verbatim from mockup core.js. */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_DISPUTES = SUPPLY_DATA.disputes
